import { generateBFFUrl } from '@/configs/apiEndPoints';
import axiosInstance from '../axiosConfig';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';
import { ECOM_OTP_VERIFY, ECOM_OTP_VERIFY_ATTEMPT } from '@/configs/ecom/apis';
import is from '@/utils/is';

export const otpVerify = async (body: { mobile_number: string; otp: string }): Promise<any> => {
  try {
    return await axiosInstance.post(generateBFFUrl(ECOM_OTP_VERIFY), {
      ...(body ?? {}),
      userAgent: 'WEB',
    });
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};

export const otpVerifyAttempt = async (body: {
  mobile_number: string;
  otp: string;
}): Promise<any> => {
  try {
    const response = await axiosInstance.post(ECOM_OTP_VERIFY_ATTEMPT, body);

    let data = response.data;

    if (is.string(data)) {
      data = JSON.parse(data);
    }
    return data;
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = (response ?? {}) as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};
